import {
  Button,
  DialogActions,
  DialogContent,
  Grid,
  CircularProgress,
} from "@mui/material";
import ExcelIcon from "./../../Assests/excel.svg";
import DownloadIcon from "./../../Assests/download.svg";
import InfoIcon from "@mui/icons-material/Info";
import CancelIconRed from "./../../Assests/cancel.svg";
import UploadingMasterFile from "./UploadingMasterFile";
import {
  handleTemplateDownLoadByType,
  handleTemplateDownLoadByTypeMedium,
  handleRerunTemplateDownload,
} from "../../Redux/Actions/InputData";
import { useSelector } from "react-redux";

function UploadMasterData(props: any) {
  const {
    getData,
    handleCancelFile,
    handleUploadFile,
    handleChangeFileUpload,
    isUploadMasterFile,
    selectRadio,
    handleUploadNow,
    handleOpenBaseLineUploader,
    isUploadBaselineData,
    isUploadScenarioData,
    handleBack,
    selectedFolderId,
    selectedScenarioId,
  } = props;

  const selectedScenario = localStorage.getItem("selectedScenarioRadio");
  const isLoading = useSelector(
    (state: any) => state.InputDataReducers.isLoading,
  );
  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId,
  );

  const getFileName = (type: number, useCaseId: number, categoryId: number) => {
    const categoryName = categoryId === 1 ? "HomeCare" : "Nutrition";
    const useCaseName = useCaseId === 1 ? "STPlanner" : "MTSuite";
    const fileTypeName = type === 1 ? "Baseline" : "Scenario";
    return `${categoryName}${useCaseName}${fileTypeName}Master_Template.xlsx`;
  };
  // short term/medium term, HC/NT and Scenario/Baseline new download
  const handleTemplateDownLoad = () => {
    let type = 1;
    if (isUploadScenarioData) {
      type = 2;
    }
    let fileName = getFileName(type, selectedUsecaseId, selectedCategoryId);

    handleTemplateDownLoadByTypeMedium(
      type,
      fileName,
      selectedCategoryId,
      selectedUsecaseId,
    );
  };

  const rerunTemplateDownload = () => {
    let type = 1;
    if (isUploadScenarioData) {
      type = 2;
    }
    let fileName = getFileName(type, selectedUsecaseId, selectedCategoryId);
    handleRerunTemplateDownload(
      selectedUsecaseId,
      selectedCategoryId,
      selectedFolderId,
      selectedScenarioId,
      type,
      fileName,
    );
  };

  return (
    <>
      {isUploadMasterFile ? (
        <UploadingMasterFile
          getData={getData}
          handleCancelFile={handleCancelFile}
          handleOpenBaseLineUploader={handleOpenBaseLineUploader}
          handleCloseDonePopup={props.handleCloseDonePopup}
        />
      ) : props.selectRadio === "masterData" ||
        selectedScenario === "createScenario" ? (
        <>
          <DialogContent className="modal-body">
            <div className="upload-file-button">
              {getData &&
                getData.map((ele: any, index: any) => {
                  return (
                    <Grid
                      container
                      spacing={1}
                      key={index}
                      className="uploadFile"
                    >
                      <Grid item xs={7} md={7} lg={7}>
                        <span>
                          {index + 1}
                          {". "}
                        </span>
                        <span> {ele.name}</span>
                      </Grid>
                      <Grid item xs={5} md={5} lg={5}>
                        <>
                          {ele.selectedFile &&
                          ele.selectedFile?.name?.length > 0 ? (
                            <div className="seletcedFilename">
                              <img src={ExcelIcon} alt="" />{" "}
                              <span>
                                {" "}
                                {ele.selectedFile?.name}
                                {/* {`(${ele.selectedFile?.size})`} */}
                              </span>{" "}
                              <span
                                className="cancel-file"
                                onClick={(e) => handleCancelFile(e, ele)}
                              >
                                <img src={CancelIconRed} alt="" />
                              </span>
                            </div>
                          ) : (
                            <>
                              <Button
                                variant="outlined"
                                className="uploadBtn"
                                onClick={(e) => handleUploadFile(e, ele, index)}
                              >
                                <img src={ExcelIcon} alt="ExcelIcon" />
                                {ele.btnName}
                              </Button>
                              <input
                                type="file"
                                id={"prefix_" + index}
                                ref={ele.ref}
                                style={{ display: "none" }}
                                multiple
                                onChange={(e) => handleChangeFileUpload(e)}
                              />
                            </>
                          )}
                        </>
                      </Grid>
                    </Grid>
                  );
                })}
            </div>

            <div className="download-templet" onClick={handleTemplateDownLoad}>
              <a>
                <img src={ExcelIcon} alt="" /> <span> Download template </span>{" "}
                <img src={DownloadIcon} alt="" />
              </a>
              <p>Download the file with multiple sheets.</p>
            </div>
            {/* <div className="note-area-upload">
              <div className="note">
                <InfoIcon className="noteinfoicon" />
                <span>Note</span>
              </div>
              <div className="note-upload-content">
                <p>
                  All validations must pass only then the data will be loaded.
                </p>
                <p>File must be lesser than 100 MB.</p>
                <p>Only excel files are supported</p>
              </div>
            </div> */}
            <DialogActions>
              <div className="modal-action">
                <Button
                  variant="outlined"
                  className="cancel"
                  onClick={handleBack}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  className="Next"
                  onClick={(e) => handleUploadNow(e, "newrun")}
                  disabled={isLoading}
                  startIcon={
                    isLoading ? (
                      <CircularProgress size={18} color="inherit" />
                    ) : null
                  }
                  // disabled={selectRadio.length == 0}
                >
                  Upload Now
                </Button>
              </div>
            </DialogActions>
          </DialogContent>
        </>
      ) : (
        <>
          <DialogContent className="modal-body">
            <div className="upload-file-button">
              {getData &&
                getData.map((ele: any, index: any) => {
                  return (
                    <Grid
                      container
                      spacing={1}
                      key={index}
                      className="uploadFile"
                    >
                      <Grid item xs={7} md={7} lg={7}>
                        <span>
                          {index + 1}
                          {". "}
                        </span>
                        <span> {ele.name}</span>
                      </Grid>
                      <Grid item xs={5} md={5} lg={5}>
                        <>
                          {ele.selectedFile &&
                          ele.selectedFile?.name?.length > 0 ? (
                            <div className="seletcedFilename">
                              <img src={ExcelIcon} alt="" />{" "}
                              <span>
                                {" "}
                                {ele.selectedFile?.name}
                                {/* {`(${ele.selectedFile?.size})`} */}
                              </span>{" "}
                              <span
                                className="cancel-file"
                                onClick={(e) => handleCancelFile(e, ele)}
                              >
                                <img src={CancelIconRed} alt="" />
                              </span>
                            </div>
                          ) : (
                            <>
                              <Button
                                variant="outlined"
                                className="uploadBtn"
                                onClick={(e) => handleUploadFile(e, ele, index)}
                              >
                                <img src={ExcelIcon} alt="ExcelIcon" />
                                {ele.btnName}
                              </Button>
                              <input
                                type="file"
                                id={"prefix_" + index}
                                ref={ele.ref}
                                style={{ display: "none" }}
                                multiple
                                onChange={(e) => handleChangeFileUpload(e)}
                              />
                            </>
                          )}
                        </>
                      </Grid>
                    </Grid>
                  );
                })}
            </div>
            <div className="download-templet" onClick={rerunTemplateDownload}>
              <a>
                <img src={ExcelIcon} alt="" /> <span> Download template </span>{" "}
                <img src={DownloadIcon} alt="" />
              </a>
              <p>Download the file with multiple sheets and data.</p>
            </div>
            <div className="note-area-upload">
              <div className="note">
                <InfoIcon className="noteinfoicon" />
                <span>Note</span>
              </div>
              <div className="note-upload-content">
                <p>
                  All validations must pass only then the data will be loaded.
                </p>
                <p>File must be lesser than 100 MB.</p>
                <p>Only excel files are supported</p>
              </div>
            </div>
            <DialogActions>
              <div className="modal-action">
                <Button
                  variant="outlined"
                  className="cancel"
                  onClick={handleBack}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  className="Next"
                  onClick={(e) => handleUploadNow(e, "rerun")}
                  disabled={isLoading}
                  startIcon={
                    isLoading ? (
                      <CircularProgress size={18} color="inherit" />
                    ) : null
                  }
                  // disabled={selectRadio.length == 0}
                >
                  {isLoading ? "Uploading..." : "Upload Now"}
                </Button>
              </div>
            </DialogActions>
          </DialogContent>
        </>
      )}
    </>
  );
}

export default UploadMasterData;
